import { developmentPlanConstants } from '../../_constants';

const initialState = { developmentPlanLoading: true, data: '', error: false };

export function developmentPlan(state = initialState, action) {
    
    switch (action.type) {
        case developmentPlanConstants.REQUEST_DEVELOPMENT_PLAN:
            return {
                developmentPlanLoading: true,
                data: '',
                error: false
            };
        case developmentPlanConstants.RECEIVE_DEVELOPMENT_PLAN:
            return {
                developmentPlanLoading: false,
                data: action.developmentPlan,
                error: false
            };
        case developmentPlanConstants.DEVELOPMENT_PLAN_ERROR:
            return {
                developmentPlanLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/developmentPlan/developmentPlan.reducer.js